export const config = {
  title: 'Gonzalez Home Leveling Services',
  meta: {
    description:
      'Gonzalez Home Leveling Services offers expert foundation leveling and repair services in Texas City, TX. Restore your home’s stability with our professional team.',
    keywords: [
      'Home Leveling Texas City',
      'Foundation Repair TX',
      'Structural Repair',
      'House Leveling Contractor',
      'Gonzalez Home Leveling Services',
    ],
    author: 'Gonzalez Home Leveling Services',
    canonicalUrl: 'https://gonzalezhomelevelingservices.com/',
  },
  sections: {
    header: {
      businessName: 'Gonzalez Home Leveling Services',
    },
    sectionB: {
      heroTitle: 'Gonzalez Home Leveling Services',
      heroSubtitle: 'Foundation Leveling & Repair Experts in Texas City, TX',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '2108807744',
      phoneLabel: '(210) 880-7744',
      heroBackgroundImage:
        'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/admins-assets/website-editor/8c5e07c1-d066-4406-b00d-a618bd0f2bbe/5a15f2df-8b0c-4ec1-8892-f88b62777a5a724d.jpg?alt=media&token=87ce974f-750e-4b69-a171-300bb63eb2fe',
      cardData: [
        {
          title: 'Foundation Specialists',
          description:
            'We focus exclusively on home leveling and structural foundation repairs.',
        },
        {
          title: 'Reliable & Experienced',
          description:
            'With years of hands-on experience, we’ve seen it all and fixed it all.',
        },
        {
          title: 'Free Estimates',
          description:
            'We provide honest, no-obligation assessments of your foundation’s condition.',
        },
      ],
      description:
        'Gonzalez Home Leveling Services provides comprehensive foundation leveling and repair services throughout Texas City, TX. Whether your home is sinking, shifting, or cracking, we deliver long-lasting, stable solutions.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'From minor adjustments to major foundation repairs, we offer the following services:',
      cards: [
        {
          title: 'Pier & Beam Repair',
          description:
            'We inspect and repair pier and beam foundations to restore level support.',
          imageSrc: 'https://media.istockphoto.com/id/1640279394/photo/finishing-touch-ending-renovation-pier-blankenberge.jpg?s=612x612&w=0&k=20&c=LnHZVp2CuykSewvI6mSGN8jVgx_FayFnYZ2lFS0KOuA=',
          imageAlt: 'Pier and Beam Foundation',
        },
        {
          title: 'Slab Foundation Repair',
          description:
            'Cracks or shifting slabs? We provide safe, permanent leveling solutions.',
          imageSrc: 'https://media.istockphoto.com/id/1419052235/photo/close-up-asian-worker-laying-down-smooth-cement-on-work-site.jpg?s=612x612&w=0&k=20&c=gt3jsotQyLnj_2MvdP7uIyejucGOpxDuu0JmfUhl2Yo=',
          imageAlt: 'Concrete Slab Foundation Repair',
        },
        {
          title: 'Mobile Home Leveling',
          description:
            'Specialized in leveling and stabilizing mobile and manufactured homes.',
          imageSrc: 'https://media.istockphoto.com/id/1071891134/photo/process-of-moving-a-house.jpg?s=612x612&w=0&k=20&c=yjg_ww5BrtdRAv8uZXTChVFBZqT7R8zit0Do7A7ZODU=',
          imageAlt: 'Mobile Home Leveling Service',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Soil Stabilization',
        'Interior Foundation Adjustment',
        'Crawlspace Leveling',
        'Shimming & Resupport',
        'Preventative Inspections',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/a6e8a123-b4d7-4385-a444-db6cabcd4bb4919e.png?alt=media&token=fbddd928-486f-43f6-9a10-12df2eabc3d0',
        alt: 'Gonzalez Home Leveling Services Team',
      },
      aboutText: [
        'At Gonzalez Home Leveling Services, we pride ourselves on delivering solid foundation solutions with integrity and precision.',
        'With a dedicated crew and deep knowledge of Texas soil conditions, our mission is to help homeowners stay safe and structurally sound for years to come.',
      ],
    },
    sectionE: {
      profileImage: "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/a6e8a123-b4d7-4385-a444-db6cabcd4bb4919e.png?alt=media&token=fbddd928-486f-43f6-9a10-12df2eabc3d0",
      profileAlt: 'Gonzalez Home Leveling Services Logo',
      businessName: 'Gonzalez Home Leveling Services',
      contact: {
        phone: '2108807744',
        phoneLabel: '(210) 880-7744',
        email: 'info@gonzalezhomelevelingservices.com',
        website: 'https://gonzalezhomelevelingservices.com/',
        address: 'Texas City, TX',
      },
      socialMedia: {
        facebook: null,
        twitter: null,
        instagram: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Texas City, TX',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3495.123456789012!2d-94.9020000!3d29.3838000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x863f5d1234567890%3A0xabcdef1234567890!2sTexas%20City%2C%20TX!5e0!3m2!1sen!2sus!4v1715098700000!5m2!1sen!2sus',
    },
  },
};

export default config;
